import BasicStackedBarChartWidget from "../components/widgets/analytics/basicStackedBarChart";
import LineChartSimple from "../components/widgets/analytics/lineChart";
import TableSearchListWidget from "../components/widgets/analytics/tableSearchList";
import BarChartDrillThroughWidget from "../components/widgets/barChartDrillThroughWidget";
import HierarchicalWidget from "../components/widgets/hierarchicalWidget";
import BarChartWidget from "../components/widgets/barChartWidget";
import BarLineComboWidget from "../components/widgets/barComboWidget";
import CandleStickWidget from "../components/widgets/candleStickWidget";
import DemandForecastWidget from "../components/widgets/demandForecastWidget";
import DonutChartWidget from "../components/widgets/donutChartWidget";
import DonutSwitchWidget from "../components/widgets/donutSwitchWidget";
import DormantChartWidget from "../components/widgets/dormantChartWidget";
import FunnelChartWidget from "../components/widgets/funnelChartWidget";
import GaugeChartWidget from "../components/widgets/gaugeChartWidget";
import GaugeGroupWidget from "../components/widgets/gaugeGroupWidget";
import LineChartWidget from "../components/widgets/lineChartWidget";
import ListWidget from "../components/widgets/listWidget";
import LostOpportunitiesWidget from "../components/widgets/lostOpportunitiesWidget";
import MagicQuadrantWidget from "../components/widgets/magicQuadrantWidget";
import MapBubbleWidget from "../components/widgets/mapBubbleWidget";
import MultiSeriesComboWidget from "../components/widgets/multiSeriesComboWidget";
import MultiSeriesLineChartWidget from "../components/widgets/multiSeriesLineChartWidget";
import MultisetBarChartSwitchWidget from "../components/widgets/multisetBarChartSwitchWidget";
import MultiSetBarChartWidget from "../components/widgets/multiSetBarChartWidget";
import RadialPolarBarWidget from "../components/widgets/radialPolarBarWidget";
import SalesTrendsForecastWidget from "../components/widgets/salesTrendsForecastWidget";
import SankeyChartWidget from "../components/widgets/sankeyChartWidget";
import ScatterPlotChartWidget from "../components/widgets/scatterPlotLocationChartWidget";
import SimpleIconWidget from "../components/widgets/simpleIconWidget";
import SmallNumberCostWidget from "../components/widgets/smallNumberCostWidget";
import SmallNumberCountWidget from "../components/widgets/smallNumberCountWidget";
import SmallNumberMultiStatsWidget from "../components/widgets/smallNumberMultiStatsWidget";
import SmallTabbedNumberWidget from "../components/widgets/smallTabbedNumberWidget";
import SmallTwinNumberWidget from "../components/widgets/smallTwinNumberWidget";
import StackedBarChartSwitchWidget from "../components/widgets/stackedBarChartSwitchWidget";
import StackedBarChartWidget from "../components/widgets/stackedBarChartWidget";
import SubRecipeWidget from "../components/widgets/subRecipeWidget";
import SunburstChartWidget from "../components/widgets/sunburstChartWidget";
import TableWidget from "../components/widgets/tableWidget";
import TrendsWidget from "../components/widgets/trendsWidget";
import UnknownWidget from "../components/widgets/unknownWidget";
import WaterfallChartWidget from "../components/widgets/waterfallChartWidget";
import BSTableWidget from "../features/businessSummary/components/bsTableWidget";
import HappeningsEventStreamWidget from "../features/happenings/components/happeningsEventStreamWidget";
import { WIDGET_TYPE } from "../types/widgets";

/** `[[w, h], [minW, minH], [maxW, maxH], resizable?, draggable?]`
 * Layout order: [xxl, xl, lg, md, sm, xs, xxs]
 */
export const WidgetsConfigurations = {
  [WIDGET_TYPE.NUM_COUNT_SM]: {
    component: SmallNumberCountWidget,
    layout: [
      [[4, 7], [4, 7], [4, 7], false, true], // xxl: 4K displays
      [[3, 7], [3, 7], [3, 7], false, true], // xl: Full HD
      [[3, 7], [3, 7], [3, 7], false, true], // lg: Large tablets
      [[2, 7], [2, 7], [2, 7], false, true], // md: Tablets
      [[3, 6], [3, 6], [3, 6], false, true], // sm: Small tablets
      [[3, 5], [3, 5], [3, 5], false, true], // xs: Mobile landscape
      [[2, 5], [2, 5], [2, 5], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.DONUT_MD]: {
    component: DonutChartWidget,
    layout: [
      [[8, 12], [8, 11], [12, 16], true, true], // xxl: 4K displays
      [[7, 11], [7, 10], [10, 14], true, true], // xl: Full HD
      [[6, 10], [6, 9], [9, 14], true, true], // lg: Large tablets
      [[4, 10], [4, 8], [8, 12], true, true], // md: Tablets
      [[6, 10], [6, 9], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [4, 8], [4, 12], false, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.BAR_MD]: {
    component: BarChartWidget,
    layout: [
      [[8, 12], [6, 12], [16, 14], true, true], // xxl: 4K displays
      [[7, 11], [5, 11], [12, 13], true, true], // xl: Full HD
      [[6, 10], [4, 10], [12, 11], true, true], // lg: Large tablets
      [[4, 10], [4, 10], [8, 11], true, true], // md: Tablets
      [[6, 10], [4, 10], [6, 11], true, true], // sm: Small tablets
      [[4, 10], [4, 10], [4, 10], false, true], // xs: Mobile landscape
      [[2, 10], [2, 10], [2, 10], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.MAP_BUBBLE_LG]: {
    component: MapBubbleWidget,
    layout: [
      [[16, 11], [8, 11], [20, 14], true, true], // xxl: 4K displays
      [[12, 10], [7, 10], [16, 13], true, true], // xl: Full HD
      [[12, 9], [6, 9], [12, 11], true, true], // lg: Large tablets
      [[8, 10], [5, 9], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 9], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], false, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.NUM_DUAL_SM]: {
    component: SmallTwinNumberWidget,
    layout: [
      [[8, 8], [8, 8], [8, 8], false, true], // xxl: 4K displays
      [[6, 7], [6, 7], [6, 7], false, true], // xl: Full HD
      [[6, 7], [6, 7], [6, 7], false, true], // lg: Large tablets
      [[4, 6], [4, 6], [4, 6], false, true], // md: Tablets
      [[6, 6], [6, 6], [6, 6], false, true], // sm: Small tablets
      [[4, 5], [4, 5], [4, 5], false, true], // xs: Mobile landscape
      [[2, 5], [2, 5], [2, 5], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.NUM_TAB_SM]: {
    component: SmallTabbedNumberWidget,
    layout: [
      [[8, 8], [8, 8], [8, 8], false, true], // xxl: 4K displays
      [[6, 7], [6, 7], [6, 7], false, true], // xl: Full HD
      [[6, 7], [6, 7], [6, 7], false, true], // lg: Large tablets
      [[4, 6], [4, 6], [4, 6], false, true], // md: Tablets
      [[6, 6], [6, 6], [6, 6], false, true], // sm: Small tablets
      [[4, 5], [4, 5], [4, 5], false, true], // xs: Mobile landscape
      [[2, 5], [2, 5], [2, 5], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.LINE_LG]: {
    component: LineChartWidget,
    layout: [
      [[16, 12], [6, 11], [20, 14], true, true], // xxl: 4K displays
      [[14, 11], [5, 10], [16, 13], true, true], // xl: Full HD
      [[12, 10], [4, 9], [12, 11], true, true], // lg: Large tablets
      [[8, 10], [4, 9], [8, 12], true, true], // md: Tablets
      [[6, 8], [4, 8], [6, 10], true, true], // sm: Small tablets
      [[4, 8], [3, 7], [4, 9], true, true], // xs: Mobile landscape
      [[2, 8], [2, 7], [2, 9], true, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.BAR_STACKED_MD]: {
    component: StackedBarChartWidget,
    layout: [
      [[16, 12], [6, 11], [20, 14], true, true], // xxl: 4K displays
      [[14, 11], [5, 10], [16, 13], true, true], // xl: Full HD
      [[12, 10], [4, 9], [12, 11], true, true], // lg: Large tablets
      [[8, 9], [4, 9], [8, 12], true, true], // md: Tablets
      [[6, 8], [4, 8], [6, 10], true, true], // sm: Small tablets
      [[4, 8], [3, 7], [4, 9], true, true], // xs: Mobile landscape
      [[2, 8], [2, 7], [2, 9], true, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.BAR_LINE_COMBO_LG]: {
    component: BarLineComboWidget,
    layout: [
      [[16, 12], [6, 11], [20, 14], true, true], // xxl: 4K displays
      [[14, 11], [5, 10], [16, 13], true, true], // xl: Full HD
      [[12, 10], [4, 9], [12, 11], true, true], // lg: Large tablets
      [[8, 10], [4, 9], [8, 12], true, true], // md: Tablets
      [[6, 8], [4, 8], [6, 10], true, true], // sm: Small tablets
      [[4, 8], [3, 7], [4, 9], false, true], // xs: Mobile landscape
      [[2, 8], [2, 7], [2, 9], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.LINE_MULTISERIES_LG]: {
    component: MultiSeriesLineChartWidget,
    layout: [
      [[16, 12], [8, 11], [20, 12], true, true], // xxl: 4K displays
      [[14, 11], [7, 10], [16, 11], true, true], // xl: Full HD
      [[12, 10], [6, 9], [14, 9], true, true], // lg: Large tablets
      [[8, 10], [4, 8], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 8], [3, 6], [4, 10], false, true], // xs: Mobile landscape
      [[2, 8], [2, 6], [2, 10], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.DONUT_DUAL_LG]: {
    component: DonutSwitchWidget,
    layout: [
      [[8, 12], [8, 11], [12, 16], true, true], // xxl: 4K displays
      [[7, 11], [7, 10], [10, 14], true, true], // xl: Full HD
      [[6, 10], [6, 9], [9, 14], true, true], // lg: Large tablets
      [[4, 10], [4, 8], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], false, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.BAR_MULTISET_MD]: {
    component: MultiSetBarChartWidget,
    layout: [
      [[16, 12], [6, 11], [20, 14], true, true], // xxl: 4K displays
      [[14, 11], [5, 10], [16, 13], true, true], // xl: Full HD
      [[12, 10], [4, 9], [12, 11], true, true], // lg: Large tablets
      [[8, 9], [4, 9], [8, 12], true, true], // md: Tablets
      [[6, 8], [4, 8], [6, 10], true, true], // sm: Small tablets
      [[4, 8], [3, 7], [4, 9], false, true], // xs: Mobile landscape
      [[2, 8], [2, 7], [2, 9], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.TRENDS_LG]: {
    component: TrendsWidget,
    layout: [
      [[16, 12], [6, 11], [20, 14], true, true], // xxl: 4K displays
      [[14, 11], [5, 10], [16, 13], true, true], // xl: Full HD
      [[12, 10], [4, 9], [12, 11], true, true], // lg: Large tablets
      [[8, 9], [4, 9], [8, 12], true, true], // md: Tablets
      [[6, 8], [4, 8], [6, 10], true, true], // sm: Small tablets
      [[4, 8], [3, 7], [4, 9], false, true], // xs: Mobile landscape
      [[2, 8], [2, 7], [2, 9], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.NUM_MULTI_STAT_SM]: {
    component: SmallNumberMultiStatsWidget,
    layout: [
      [[4, 7], [4, 7], [4, 7], false, true], // xxl: 4K displays
      [[3, 7], [3, 7], [3, 7], false, true], // xl: Full HD
      [[3, 7], [3, 7], [3, 7], false, true], // lg: Large tablets
      [[2, 7], [2, 7], [2, 7], false, true], // md: Tablets
      [[3, 6], [3, 6], [3, 6], false, true], // sm: Small tablets
      [[3, 5], [3, 5], [3, 5], false, true], // xs: Mobile landscape
      [[2, 5], [2, 5], [2, 5], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.NUM_COST_SM]: {
    component: SmallNumberCostWidget,
    layout: [
      [[4, 7], [4, 7], [4, 7], false, true], // xxl: 4K displays
      [[3, 7], [3, 7], [3, 7], false, true], // xl: Full HD
      [[3, 7], [3, 7], [3, 7], false, true], // lg: Large tablets
      [[2, 7], [2, 7], [2, 7], false, true], // md: Tablets
      [[3, 6], [3, 6], [3, 6], false, true], // sm: Small tablets
      [[3, 5], [3, 5], [3, 5], false, true], // xs: Mobile landscape
      [[2, 5], [2, 5], [2, 5], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.SCATTER_PLOT_LG]: {
    component: ScatterPlotChartWidget,
    layout: [
      [[16, 14], [8, 11], [20, 18], true, true], // xxl: 4K displays
      [[14, 13], [7, 10], [16, 16], true, true], // xl: Full HD
      [[12, 12], [6, 9], [12, 14], true, true], // lg: Large tablets
      [[8, 11], [4, 8], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], false, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.SANKEY_CHART_LG]: {
    component: SankeyChartWidget,
    layout: [
      [[16, 14], [8, 11], [20, 18], true, true], // xxl: 4K displays
      [[14, 13], [7, 10], [16, 16], true, true], // xl: Full HD
      [[12, 12], [6, 9], [12, 14], true, true], // lg: Large tablets
      [[8, 11], [4, 8], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], false, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.RADIAL_POLAR_BAR_LG]: {
    component: RadialPolarBarWidget,
    layout: [
      [[8, 12], [8, 11], [12, 16], true, true], // xxl: 4K displays
      [[7, 11], [7, 10], [10, 14], true, true], // xl: Full HD
      [[6, 10], [6, 9], [9, 14], true, true], // lg: Large tablets
      [[4, 10], [4, 8], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], false, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.GAUGE_CHART_MD]: {
    component: GaugeChartWidget,
    layout: [
      [[4, 10], [4, 10], [6, 12], true, true], // xxl: 4K displays
      [[3, 9], [3, 9], [5, 11], true, true], // xl: Full HD
      [[3, 8], [3, 8], [4, 10], true, true], // lg: Large tablets
      [[3, 8], [3, 8], [4, 10], true, true], // md: Tablets
      [[3, 8], [3, 8], [4, 10], true, true], // sm: Small tablets
      [[3, 8], [3, 8], [4, 10], true, true], // xs: Mobile landscape
      [[2, 8], [2, 8], [3, 10], true, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.CANDLESTICK_CHART_LG]: {
    component: CandleStickWidget,
    layout: [
      [[16, 14], [8, 11], [20, 18], true, true], // xxl: 4K displays
      [[14, 13], [7, 10], [16, 16], true, true], // xl: Full HD
      [[12, 12], [6, 9], [12, 14], true, true], // lg: Large tablets
      [[8, 11], [4, 8], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], false, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], true, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.MAGIC_QUADRANT_LG]: {
    component: MagicQuadrantWidget,
    layout: [
      [[16, 14], [8, 11], [20, 18], true, true], // xxl: 4K displays
      [[14, 13], [7, 10], [16, 16], true, true], // xl: Full HD
      [[12, 12], [6, 9], [12, 14], true, true], // lg: Large tablets
      [[8, 11], [4, 8], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], false, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], true, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.FORECAST_CHART_LG]: {
    component: DemandForecastWidget,
    layout: [
      [[16, 14], [8, 11], [20, 18], true, true], // xxl: 4K displays
      [[14, 13], [7, 10], [16, 16], true, true], // xl: Full HD
      [[12, 12], [6, 9], [12, 14], true, true], // lg: Large tablets
      [[8, 11], [4, 8], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], false, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], true, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.FUNNEL_CHART_LG]: {
    component: FunnelChartWidget,
    layout: [
      [[8, 12], [6, 11], [16, 16], true, true], // xxl: 4K displays
      [[7, 11], [5, 10], [14, 14], true, true], // xl: Full HD
      [[6, 10], [4, 9], [12, 12], true, true], // lg: Large tablets
      [[4, 10], [4, 8], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], true, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], true, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.LIST_MD]: {
    component: ListWidget,
    layout: [
      [[8, 12], [6, 11], [16, 16], true, true], // xxl: 4K displays
      [[7, 11], [5, 10], [14, 14], true, true], // xl: Full HD
      [[6, 10], [4, 9], [12, 12], true, true], // lg: Large tablets
      [[4, 10], [4, 8], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], true, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], true, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.DORMANT_CHART_MD]: {
    component: DormantChartWidget,
    layout: [
      [[8, 12], [6, 11], [14, 16], true, true], // xxl: 4K displays
      [[7, 11], [5, 10], [12, 14], true, true], // xl: Full HD
      [[6, 10], [4, 9], [11, 12], true, true], // lg: Large tablets
      [[4, 10], [4, 8], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], false, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.LOST_OPPORTUNITIES_LG]: {
    component: LostOpportunitiesWidget,
    layout: [
      [[16, 14], [8, 11], [20, 18], true, true], // xxl: 4K displays
      [[14, 13], [7, 10], [16, 16], true, true], // xl: Full HD
      [[12, 12], [6, 9], [12, 14], true, true], // lg: Large tablets
      [[8, 11], [4, 8], [8, 12], true, true], // md: Tablets
      [[6, 8], [4, 6], [6, 10], true, true], // sm: Small tablets
      [[4, 8], [3, 6], [4, 9], false, true], // xs: Mobile landscape
      [[2, 8], [2, 6], [2, 9], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.MULTI_SERIES_COMBO_CHART]: {
    component: MultiSeriesComboWidget,
    layout: [
      [[16, 12], [6, 11], [18, 16], true, true], // xxl: 4K displays
      [[14, 11], [5, 10], [16, 14], true, true], // xl: Full HD
      [[12, 10], [4, 9], [11, 12], true, true], // lg: Large tablets
      [[8, 10], [4, 9], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], false, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.SUNBURST_CHART_MD]: {
    component: SunburstChartWidget,
    layout: [
      [[8, 12], [8, 11], [12, 16], true, true], // xxl: 4K displays
      [[7, 11], [7, 10], [10, 14], true, true], // xl: Full HD
      [[6, 10], [6, 9], [9, 14], true, true], // lg: Large tablets
      [[4, 10], [4, 8], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], false, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.BAR_MULTISET_SWITCH_MD]: {
    component: MultisetBarChartSwitchWidget,
    layout: [
      [[16, 12], [6, 11], [20, 14], true, true], // xxl: 4K displays
      [[14, 11], [5, 10], [16, 13], true, true], // xl: Full HD
      [[12, 10], [4, 9], [12, 11], true, true], // lg: Large tablets
      [[8, 9], [4, 9], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], true, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], true, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.WATERFALL_CHART_LG]: {
    component: WaterfallChartWidget,
    layout: [
      [[16, 12], [6, 11], [20, 14], true, true], // xxl: 4K displays
      [[14, 11], [5, 10], [16, 13], true, true], // xl: Full HD
      [[12, 10], [4, 9], [12, 11], true, true], // lg: Large tablets
      [[8, 10], [4, 9], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], false, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.BAR_STACKED_SWITCH_MD]: {
    component: StackedBarChartSwitchWidget,
    layout: [
      [[16, 12], [6, 11], [20, 14], true, true], // xxl: 4K displays
      [[14, 11], [5, 10], [16, 13], true, true], // xl: Full HD
      [[12, 10], [4, 9], [12, 11], true, true], // lg: Large tablets
      [[8, 9], [4, 9], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], true, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], true, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.GAUGE_GROUP_LG]: {
    component: GaugeGroupWidget,
    layout: [
      [[16, 12], [6, 11], [20, 14], true, true], // xxl: 4K displays
      [[14, 11], [5, 10], [16, 13], true, true], // xl: Full HD
      [[12, 10], [4, 9], [12, 11], true, true], // lg: Large tablets
      [[8, 9], [4, 9], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], true, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], true, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.STACKED_BAR_CHART]: {
    component: BasicStackedBarChartWidget,
    layout: [
      [[16, 12], [6, 11], [20, 14], true, true], // xxl: 4K displays
      [[14, 11], [5, 10], [16, 13], true, true], // xl: Full HD
      [[12, 10], [4, 9], [12, 11], true, true], // lg: Large tablets
      [[8, 9], [4, 9], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], true, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], true, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.BS_TABLE_WIDGET]: {
    component: BSTableWidget,
    layout: [
      [[2, 12], [2, 11], [4, 16], false, false], // xxl: 4K displays
      [[1, 11], [1, 10], [3, 14], false, false], // xl: Full HD
      [[1, 10], [1, 9], [2, 12], false, false], // lg: Large tablets
      [[1, 10], [1, 8], [2, 12], false, false], // md: Tablets
      [[1, 10], [1, 8], [2, 12], false, false], // sm: Small tablets
      [[1, 10], [1, 8], [2, 12], false, false], // xs: Mobile landscape
      [[1, 10], [1, 8], [2, 12], false, false] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.SIMPLE_ICON_WIDGET]: {
    component: SimpleIconWidget,
    layout: [
      [[4, 7], [4, 7], [4, 7], false, true], // xxl: 4K displays
      [[3, 7], [3, 7], [3, 7], false, true], // xl: Full HD
      [[3, 7], [3, 7], [3, 7], false, true], // lg: Large tablets
      [[2, 7], [2, 7], [2, 7], false, true], // md: Tablets
      [[3, 6], [3, 6], [3, 6], false, true], // sm: Small tablets
      [[3, 5], [3, 5], [3, 5], false, true], // xs: Mobile landscape
      [[2, 5], [2, 5], [2, 5], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.SUB_RECIPE_WIDGET]: {
    component: SubRecipeWidget,
    layout: [
      [[16, 12], [6, 11], [20, 14], true, true], // xxl: 4K displays
      [[14, 11], [5, 10], [16, 13], true, true], // xl: Full HD
      [[12, 10], [4, 9], [12, 11], true, true], // lg: Large tablets
      [[8, 9], [4, 9], [8, 12], true, true], // md: Tablets
      [[6, 8], [4, 8], [6, 10], true, true], // sm: Small tablets
      [[4, 8], [3, 7], [4, 9], true, true], // xs: Mobile landscape
      [[2, 8], [2, 7], [2, 9], true, true] // xxs: Mobile portrait
    ]
  },
  ["UNKNOWN_TYPE"]: {
    component: UnknownWidget,
    layout: [
      [[4, 8], [4, 8], [8, 12], true, true], // xxl: 4K displays
      [[3, 7], [3, 7], [6, 10], true, true], // xl: Full HD
      [[3, 7], [3, 7], [4, 8], true, true], // lg: Large tablets
      [[2, 6], [2, 6], [4, 8], true, true], // md: Tablets
      [[3, 7], [2, 7], [4, 8], true, true], // sm: Small tablets
      [[3, 7], [3, 7], [4, 8], true, true], // xs: Mobile landscape
      [[2, 7], [2, 7], [2, 8], true, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.HAPPENINGS_EVENT_STREAM]: {
    component: HappeningsEventStreamWidget,
    layout: [
      [[8, 8], [8, 8], [8, 8], false, true], // xxl: 4K displays
      [[6, 7], [6, 7], [6, 7], false, true], // xl: Full HD
      [[6, 7], [6, 7], [6, 7], false, true], // lg: Large tablets
      [[4, 6], [4, 6], [4, 6], false, true], // md: Tablets
      [[6, 7], [6, 7], [6, 7], false, true], // sm: Small tablets
      [[4, 7], [4, 7], [4, 7], false, true], // xs: Mobile landscape
      [[2, 7], [2, 7], [2, 7], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.CUSTOM_BAR_CHART_DRILLTHROUGH]: {
    component: BarChartDrillThroughWidget,
    layout: [
      [[16, 12], [6, 11], [20, 14], true, true], // xxl: 4K displays
      [[14, 11], [5, 10], [16, 13], true, true], // xl: Full HD
      [[12, 10], [4, 9], [12, 11], true, true], // lg: Large tablets
      [[8, 10], [4, 9], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], true, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.TRENDS_GROUP_LG]: {
    component: SalesTrendsForecastWidget,
    layout: [
      [[16, 12], [6, 11], [20, 14], true, true], // xxl: 4K displays
      [[14, 11], [5, 10], [16, 13], true, true], // xl: Full HD
      [[12, 10], [4, 9], [12, 11], true, true], // lg: Large tablets
      [[8, 9], [4, 9], [8, 12], true, true], // md: Tablets
      [[6, 8], [4, 8], [6, 10], true, true], // sm: Small tablets
      [[4, 8], [3, 7], [4, 9], false, true], // xs: Mobile landscape
      [[2, 8], [2, 7], [2, 9], false, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.TABLE_WIDGET]: {
    component: TableWidget,
    layout: [
      [[8, 12], [6, 11], [16, 16], true, true], // xxl: 4K displays
      [[7, 11], [5, 10], [14, 14], true, true], // xl: Full HD
      [[6, 10], [4, 9], [12, 12], true, true], // lg: Large tablets
      [[4, 10], [4, 8], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], true, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], true, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.TABLE_SEARCH_LIST_WIDGET]: {
    component: TableSearchListWidget,
    layout: [
      [[8, 12], [6, 11], [16, 16], true, true], // xxl: 4K displays
      [[7, 11], [5, 10], [14, 14], true, true], // xl: Full HD
      [[6, 10], [4, 9], [12, 12], true, true], // lg: Large tablets
      [[4, 10], [4, 8], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], true, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], true, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.SIMPLE_LINE_CHART_LG]: {
    component: LineChartSimple,
    layout: [
      [[16, 12], [6, 11], [20, 14], true, true], // xxl: 4K displays
      [[14, 11], [5, 10], [16, 13], true, true], // xl: Full HD
      [[12, 10], [4, 9], [12, 11], true, true], // lg: Large tablets
      [[8, 10], [4, 9], [8, 12], true, true], // md: Tablets
      [[6, 8], [4, 8], [6, 10], true, true], // sm: Small tablets
      [[4, 8], [3, 7], [4, 9], true, true], // xs: Mobile landscape
      [[2, 8], [2, 7], [2, 9], true, true] // xxs: Mobile portrait
    ]
  },
  [WIDGET_TYPE.HIERARCHICAL_WIDGET]: {
    component: HierarchicalWidget,
    layout: [
      [[16, 14], [8, 11], [20, 18], true, true], // xxl: 4K displays
      [[14, 13], [7, 10], [16, 16], true, true], // xl: Full HD
      [[12, 12], [6, 9], [12, 14], true, true], // lg: Large tablets
      [[8, 11], [4, 8], [8, 12], true, true], // md: Tablets
      [[6, 10], [4, 8], [6, 12], true, true], // sm: Small tablets
      [[4, 10], [3, 8], [4, 12], true, true], // xs: Mobile landscape
      [[2, 10], [2, 8], [2, 12], true, true] // xxs: Mobile portrait
    ]
  }
};
